// extracted by mini-css-extract-plugin
export default {"link":"login-component_link__tUmeP"};